class PickupWizardController {
    constructor(addressService, timeslotService, fulfilmentSteps, loginService, shopperService, sessionStorage, settings) {
        this.addressService = addressService;
        this.timeslotService = timeslotService;
        this.fulfilmentSteps = fulfilmentSteps;
        this.loginService = loginService;
        this.shopperService = shopperService;
        this.sessionStorage = sessionStorage;
        this.settings = settings;

        this.timeTable = [];
        this.hasFinished = false;
        this.sessionStorageKey = 'login:trigger';
    }

    $onInit() {
        if (this.currentAddress) {
            this.fetchTimeslots(this.currentAddress.AreaId);
        }

        if (this.currentTimeslot) {
            this.selectedDate = this.currentTimeslot.Date;
            this.selectedTime = this.currentTimeslot.Time;
        }

        const primaryAddress = this.addressService.getPrimaryAddress();

        this.selectedBillingAddressId = primaryAddress ? primaryAddress.AddressId : null;
    }

    $onChanges(changes) {
        if (changes.isActive) {
            if (changes.isActive.currentValue) {
                this.hasFinished = false;
            } else if (!this.hasFinished) {
                if (this.currentStep === this.fulfilmentSteps.address) {
                    this.decideAddressLater();
                } else if (this.currentStep === this.fulfilmentSteps.timeslot) {
                    this.decideTimeLater();
                }
            }
        }
    }

    ensureLoggedIn(callback) {
        if (this.shopperService.IsGuest) {
            this.loginService.promptForLogin(this.loginService.LoginToSetDeliveryOrPickupAddressMessage, undefined, undefined, undefined, () => {
                if (this.allowDecideLater) {
                    this.sessionStorage.set(this.sessionStorageKey, 'GuestLoginToSaveAddress');
                }
                callback();
            });
        } else {
            callback();
        }
    }

    setCollectionAddress(address) {
        this.ensureLoggedIn(() => {
            this.currentAddress = address;
            this.change();

            if (this.allowDecideLater && !this.settings.fulfilmentTimetable.showTimesWhenAllowDecideLater) {
                this.decideTimeLater();
            } else {
                this.fetchTimeslots(address.AreaId);
                this.currentStep = this.fulfilmentSteps.timeslot;
            }
        });
    }

    fetchTimeslots(areaId) {
        this.timeslotService.listTimeslots(areaId, 'Pickup').then((dates) => {
            this.reservedWindow = this.timeslotService.findReservedWindow(dates);
            this.timeTable = dates;
            return dates;
        });
    }

    decideAddressLater() {
        this.currentAddress = null;
        this.selectedTime = null;
        this.selectedDate = null;
        this.finish();
    }

    setDate(date) {
        this.selectedDate = date;
    }

    setTime(time) {
        this.selectedTime = time;
        if (this.shouldShowBilling && !this.addressService.getPrimaryAddress()) {
            this.change();
            this.currentStep = this.fulfilmentSteps.billing;
        } else {
            this.finish();
        }
    }

    decideTimeLater() {
        this.selectedTime = null;
        this.selectedDate = null;
        this.finish();
    }

    saveNewManualAddressForBilling(address) {
        this.addressService.saveNewManualAddressForBilling(address)
            .then((addressResponse) => {
                this.selectedBillingAddressId = addressResponse.Address.AddressId;
                this.finish();
            });
    }

    saveNewAutoAddressForBilling(address) {
        this.addressService.saveNewAutoAddressForBilling(address)
            .then((addressResponse) => {
                this.selectedBillingAddressId = addressResponse.Address.AddressId;
                this.finish();
            });
    }

    setSavedAddressAsBilling(address) {
        this.selectedBillingAddressId = address.AddressId;
        this.finish();
    }

    change() {
        this.onFulfilmentChange(this.getFulfilmentInfo());
    }

    finish() {
        this.hasFinished = true;
        this.onFulfilmentSelected(this.getFulfilmentInfo());
    }

    getFulfilmentInfo() {
        return {
            fulfilmentInfo: {
                address: this.currentAddress,
                fulfilmentMethod: 'Pickup',
                fulfilmentWindow: {
                    date: this.selectedDate,
                    time: this.selectedTime,
                },
                billingAddressId: this.selectedBillingAddressId,
            },
        };
    }
}

PickupWizardController.$inject = ['AddressService', 'FulfilmentTimeslotService', 'FulfilmentSteps', 'LoginService', 'ShopperService', 'SessionStorageWrapper', 'Settings'];

const pickupWizardComponentDefinition = {
    controller: PickupWizardController,
    bindings: {
        shouldShowBilling: '<?',
        onFulfilmentSelected: '&',
        onFulfilmentChange: '&',
        allowDecideLater: '<?',
        currentAddress: '<?',
        currentTimeslot: '<?',
        currentStep: '=',
        isActive: '<',
        isNewFulfilmentMethodSelector: '<?',
    },
    template: require('./pickup-wizard.component.html').trim(),
};

module.exports = {
    PickupWizardController,
    pickupWizardComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/fulfilment/pickup/pickup-wizard.component.js